<template>
  <div class="margintop20">
    <h1>Credit Card</h1>
    <h3>{{ labels[1076] }}</h3><!-- Select and enter your card information: -->
    <div id="creditCardPayment">
      <div id="component-container"></div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import useCMS from '../../shared/composables/useCMS'
import { initializeAdyenCheckout } from '../../adyen'
import qs from "qs"
import axios from "axios"

export default {
  name: 'AdyenPayments',
  emits: ['billing-updated','stored-payment'],
  setup(props, { emit }) {
    const { labels } = useCMS()
    let paymentTerms = ref(false)
    let paymentTermsReady = ref(false)
    let checkout = null
    let cardComponent = null
    let paymentMethodSaved = ref(false)
    let storePaymentMethodLabel = ref('Store Payment Method')

    // Define style object - https://docs.adyen.com/payment-methods/cards/custom-card-integration/#styling
    let styleObject = {
      base: {
        background: '#D8D8D8',
        color: 'black',
        fontSize: '16px',
        fontSmoothing: 'antialiased',
        fontFamily: 'Helvetica',
        lineHeight: '1em',
      },
      error: {
        color: 'red'
      },
      placeholder: {
        color: '#D8D8D8'
      },
      validated: {
        color: 'green'
      }
    }

    const initializeAdyen = async () => {
      try {
        checkout = await initializeAdyenCheckout()
        cardComponent = checkout.create('card', {
          type: 'card',
          styles: styleObject,
          showPayButton: false,
          hasHolderName: true,
          holderNameRequired: true,
          positionHolderNameOnTop: true,
          analytics: {
            enabled: true
          },
          onChange: async (state, actions) => {
            try {
              if (state.isValid) {
                const params = qs.stringify({
                  paymentData: JSON.stringify(state.data),
                })

                let response = await axios.post('/actions/cart.cfc?method=storeTokenData', params)
                let result = await response.data.success

                // If the response has failed, reject the payment
                if (!result) {
                  actions.reject()
                  paymentMethodSaved.value = false
                  return
                } else {
                  emit('stored-payment', true)
                  paymentMethodSaved.value = true
                  storePaymentMethodLabel.value = 'Payment Method Stored'
                }
              } else {
                emit('stored-payment', false)
                console.error('Payment data is invalid')
              }
            } catch (error) {
              emit('stored-payment', false)
              console.error('Error handling action:', error)
            }
          },
          onLoad: () => {
            console.log('Card component loaded')
            cardComponent.setStatus('loading')
          },
          onConfigSuccess: (result) => {
            console.log('Configuration success:', result)
            cardComponent.setStatus('ready')
          },
          onError: (error) => {
            console.error('Error loading card component:', error)
          }
        }).mount('#component-container')
      } catch (error) {
        console.error('Error initializing Adyen:', error)
      }
    }

    const submitPayment = async () => {
      try {
        cardComponent.submit()
      } catch (error) {
        console.error('Error submitting payment:', error)
      }
    }

    onMounted(() => {
      emit('billing-updated', false)
      initializeAdyen()
    })

    return {
      labels,
      paymentMethodSaved,
      paymentTerms,
      paymentTermsReady,
      storePaymentMethodLabel,
      submitPayment,
    }
  }
}
</script>